import { render, staticRenderFns } from "./ContactsMessangers.vue?vue&type=template&id=11fcea08&scoped=true&"
import script from "./ContactsMessangers.vue?vue&type=script&lang=js&"
export * from "./ContactsMessangers.vue?vue&type=script&lang=js&"
import style0 from "./ContactsMessangers.vue?vue&type=style&index=0&id=11fcea08&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fcea08",
  null
  
)

export default component.exports